export const SET_USER = "SET_USER";
export const SET_PLAYING = "SET_PLAYING";
export const SET_ITEM = "SET_ITEM";

export const SET_DISCOVER_WEEKLY = "SET_DISCOVER_WEEKLY";
export const SET_TOKEN = "SET_TOKEN";

export const SET_SPOTIFY = "SET_SPOTIFY";
export const SET_PLAYLISTS = "SET_PLAYLISTS";
export const SET_SEARCH = "SET_SEARCH";
export const SET_TRACKS = "SET_TRACKS";


export const SET_ERROR = "SET_ERROR";
export const SET_SHOWERROR = "SET_SHOWERROR";
export const SET_FETCHING = "SET_FETCHING";

export const SET_PLAYLIST = "SET_PLAYLIST";

export const SET_HOME = "SET_HOME";
export const RESET = "RESET";



